import { PAGE_NAMES, PAGES } from "../../types/pages"
import { NavNode } from "./navigation.types"

export const NAVIGATION: NavNode[] = [
  {
    id: "section-campaigns",
    kind: "section",
    label: "CAMPAIGNS",
    children: [
      {
        id: "opportunities",
        label: PAGE_NAMES.OPPORTUNITIES_REPORT,
        path: PAGES["Opportunities report"],
        iconName: "bulb",
      },
      {
        id: "projects",
        label: PAGE_NAMES.PROJECTS,
        path: PAGES["Projects"],
        iconName: "project",
      },
    ],
  },
  {
    id: "section-manage",
    kind: "section",
    label: "MANAGE",
    children: [
      {
        id: "advertising",
        label: PAGE_NAMES.ADVERTISING,
        path: PAGES["Advertising"],
        iconName: "notification",
      },
    ],
  },
  {
    id: "section-history",
    kind: "section",
    label: "HISTORY",
    children: [
      {
        id: "history",
        label: PAGE_NAMES.HISTORY,
        path: PAGES["History"],
        iconName: "history",
      },
    ],
  },
  {
    id: "section-settings",
    kind: "section",
    label: "SETTINGS",
    children: [
      {
        id: "filter",
        label: PAGE_NAMES.FILTER,
        path: PAGES["Filter"],
        iconName: "filter",
      },
      {
        id: "settings-acos",
        label: PAGE_NAMES.SETTINGS_ACOS,
        path: PAGES["ACOS Filter"],
        iconName: "percentage",
      },
      {
        id: "settings-other",
        label: PAGE_NAMES.SETTINGS_OTHER,
        path: PAGES["Other Filter"],
        iconName: "control",
      },
      {
        id: "users",
        label: PAGE_NAMES.USERS,
        path: PAGES["Users"],
        iconName: "team",
      },
    ],
  },
]
